export default "__VITE_ASSET__DFySgsWH__"